import React, { useContext } from 'react';

import MarkdownToJsx from '../markdown-to-jsx/markdown-to-jsx.component';

import './text-block.styles.scss';

import { TabInfoContext } from '../../contexts/tab-info.context';
import { GlobalContext } from '../../contexts/global.context';

export default function TextBlock({ blockName }) {
  const { display, selectedSubTab, overlayDataDate, overlayFilename, chartData } = useContext(GlobalContext);
  const { tabsSharedState, componentFns } = useContext(TabInfoContext);

  const blockMdFileName = (componentFns && blockName in componentFns) ? componentFns[blockName]({ selectedSubTab, display, overlayDataDate, overlayFilename, tabsSharedState, chartData }) : null;

  return (
    <div className='text-block'>
      {blockMdFileName ?
        <MarkdownToJsx
          path={`${process.env.PUBLIC_URL}/markdown/${blockMdFileName}`}
        />
        :
        ''
      }
    </div>
  );
}